import type { IProps, ModalFooterActionsCancelFactory } from "./modal-footer-actions-cancel.types";
import styles from "../../../modal.module.scss";
import { polymorphicComponentWrapper } from "../../../../../utilities";
import { Button } from "../../../../button";

const ModalFooterActionsCancel = polymorphicComponentWrapper<ModalFooterActionsCancelFactory, IProps>(
    "ModalFooterActionsCancel",
    ({ text, ...otherProps }, ref) => {
        return (
            <Button
                variant="default"
                ref={ref}
                className={styles["footer-actions-cancel"]}
                data-testid="cancel-button"
                {...otherProps}
            >
                {text || "Cancel"}
            </Button>
        );
    }
);

export { ModalFooterActionsCancel };
